import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import React = require('react');


export function PreLoginMessage() {
    const preLoginMessage = ServerSettingsUnauthenticated.preloginCustomization();

    if (!!preLoginMessage && !!preLoginMessage?.preloginNotificationImgUrl) {
        return <a className='tb-login-notification-img'
            href={preLoginMessage.preloginNotificationImgLink}
            target='_blank' rel='noopener noreferrer'>
            <img src={preLoginMessage.preloginNotificationImgUrl} alt='' />
        </a>;
    }

    return null;
}